const moedaInteira = new Intl.NumberFormat("pt-BR", {
  style: "currency",
  currency: "BRL",
  maximumFractionDigits: 0,
});
const inteiro = new Intl.NumberFormat("pt-BR");
const umaCasa = new Intl.NumberFormat("pt-BR", { minimumFractionDigits: 1, maximumFractionDigits: 1 });
const porcentagem = new Intl.NumberFormat("pt-BR", {
  style: "percent",
  minimumFractionDigits: 1,
  maximumFractionDigits: 1,
});

/** Formato pt-BR dos numeros do dashboard. `null` vira travessao, nunca "NaN". */
export const formatar = {
  moeda: (valor: number | null) => (valor === null ? "—" : moedaInteira.format(valor)),
  multiplicador: (valor: number | null) => (valor === null ? "—" : `${umaCasa.format(valor)}x`),
  quantidade: (valor: number) => inteiro.format(valor),
  porcentagem: (fracao: number | null) => (fracao === null ? "—" : porcentagem.format(fracao)),
  /** Dias inteiros: "1 dia", "21 dias". */
  dias: (valor: number | null) =>
    valor === null ? "—" : `${inteiro.format(Math.round(valor))} ${Math.round(valor) === 1 ? "dia" : "dias"}`,
  /** Duracao em minutos: "8 min", "1 h 35 min", "2 h". */
  duracao: (minutos: number | null) => {
    if (minutos === null) return "—";
    const total = Math.round(minutos);
    if (total < 60) return `${total} min`;
    const horas = Math.floor(total / 60);
    const resto = total % 60;
    return resto === 0 ? `${horas} h` : `${horas} h ${resto} min`;
  },
  /** Variacao com sinal explicito: "+12,4%" / "−3,0%". */
  variacao: (fracao: number) =>
    `${fracao > 0 ? "+" : fracao < 0 ? "−" : ""}${porcentagem.format(Math.abs(fracao))}`,
  /** Instante como a clinica le, no fuso de Sao Paulo: "15/01/2026 às 09:00". */
  momento: (iso: string) => {
    const data = new Date(iso);
    const dia = data.toLocaleDateString("pt-BR", { timeZone: "America/Sao_Paulo" });
    const hora = data.toLocaleTimeString("pt-BR", { timeZone: "America/Sao_Paulo", hour: "2-digit", minute: "2-digit" });
    return `${dia} às ${hora}`;
  },
  data: (iso: string) => new Date(iso).toLocaleDateString("pt-BR", { timeZone: "America/Sao_Paulo" }),
};
